import { Languages } from "lucide-react";
import { LANGUAGES, LANGUAGE_ENDONYMS, normalizeLanguage } from "../language.js";
import { t } from "../strings.js";

// ITEM 14(c) — **THE ONE CONTROL THAT CHOOSES A LANGUAGE**, built to ITEM 6's `ThemeChoice` shape on
// purpose: a preference on the account, painted immediately, cached on the device, written partially.
// Inventing a second shape for the second preference this site has is how two preferences end up with
// two bugs.
//
// Hookless (R7/R8's entry requirement), so `scripts/item14-strings.mjs` CALLS it once per language and
// reads the tree back. The state and the writing live at the app ROOT, which already owns
// `room_state` — a second writer for one key is a second answer to what is saved.
//
// THREE THINGS IN HERE THAT ARE NOT DECORATION:
//
//   · **EVERY LANGUAGE IS NAMED IN ITSELF.** A member who reads no English cannot find "Spanish" in a
//     list. `LANGUAGE_ENDONYMS` is the roster and "Español" is legible to everybody.
//   · **BOTH CHIPS ARE ALWAYS RENDERED AND ONE IS `aria-pressed`.** A single toggle labelled
//     "Español" says what it WILL do, never what is on, and a member who cannot see which is chosen
//     taps it to find out.
//   · **THE CHIP CARRIES `lang` ON ITSELF.** A screen reader takes its pronunciation from that
//     attribute (ITEM 14a's whole argument), so "Español" sitting inside an English document without
//     it is announced letter-mangled in an English voice — on the one control a Spanish-reading
//     member has to find first.
//
// It is a ROSTER WALK, never two hand-written buttons: a third language is one entry in
// `src/language.js` and this control grows a chip by existing.
export function LanguageChoice({ language, onChoose }: { language: string; onChoose: (language: string) => void }) {
  const current = normalizeLanguage(language);
  return (
    <div className="language-choice">
      <h3 className="language-choice__head">
        <Languages size={15} aria-hidden="true" /> {t(current, "language.heading")}
      </h3>
      {/* S7-2, her ruling (2026-08-05): the prose is GONE. This panel is the TITLE and the CHOICE.
          `language.note` said "The house speaks to you in this. The words of a working are never
          translated." — **and the sacred-verbatim LAW is untouched by removing it**, because that
          law lives in `src/language.js` and is enforced in the engine. A sentence in a dropdown was
          never what kept a psalm from being paraphrased. The catalog row is DELETED rather than
          left unread (`item14-strings.mjs` goes red about a row nobody reads). */}
      <div className="language-choice__row">
        {LANGUAGES.map((code) => (
          <button
            key={code}
            type="button"
            lang={code}
            className={code === current ? `language-chip language-chip--${code} is-on` : `language-chip language-chip--${code}`}
            onClick={() => onChoose(code)}
            aria-pressed={code === current}
            // ITEM 7's law: the face says what IS, the accessible name says what a TAP DOES. So the
            // chip she is already on is named by its own text and `aria-pressed` alone — labelling it
            // "Switch to English" would describe an act that tapping it does not perform.
            aria-label={code === current ? undefined : t(current, "language.choose", { language: LANGUAGE_ENDONYMS[code] })}
          >
            {LANGUAGE_ENDONYMS[code]}
          </button>
        ))}
      </div>
    </div>
  );
}
